import React, { Component } from 'react';
import SocketConnect from '../shared/socketConnect';
import LoadSpinner from '../shared/loadSpinner';
import FlipMove from 'react-flip-move';

/* THREE.js */
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { VertexNormalsHelper } from 'three/examples/jsm/helpers/VertexNormalsHelper';
import { PDBLoader } from 'three/examples/jsm/loaders/PDBLoader';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

import { Holistic, POSE_CONNECTIONS, FACEMESH_TESSELATION,
        FACEMESH_RIGHT_EYE, FACEMESH_RIGHT_EYEBROW, FACEMESH_LEFT_EYE,
        FACEMESH_LEFT_EYEBROW, FACEMESH_FACE_OVAL, FACEMESH_LIPS,
        POSE_LANDMARKS } from '@mediapipe/holistic/holistic';

import { Hands, HAND_CONNECTIONS } from '@mediapipe/hands/hands';
import { Camera } from '@mediapipe/camera_utils/camera_utils';
import { drawConnectors, drawLandmarks } from '@mediapipe/drawing_utils/drawing_utils';

/* Socket */
var localSock = null, imgObj = null;

/* Images */
import susie1 from '../../assets/susie1.jpg';
import susie2 from '../../assets/susie2.jpg';
import susie3 from '../../assets/susie3.jpg';
import susie4 from '../../assets/susie4.jpg';
import susie5 from '../../assets/susie5.jpg';
import susie6 from '../../assets/susie6.jpg';
import susie7 from '../../assets/susie7.jpg';
import susie8 from '../../assets/susie8.jpg';
import susie9 from '../../assets/susie9.jpg';

class Susie extends Component{
    constructor(props) {
        super(props);
        this.state = {
            susieLoading: false, displayFilters: false, 
            selectedFilter: null, susieLoading: false,
            videoFilter: null, videoFace: true,
            videoFlip: false, userId: null,
            filterTags:[], frontMap:{},
            filterList:[
                { title: "Facial Recognition", img: susie1, type: 0, tags:true, filter: "faceRecognition" },
                { title: "Object Detection", img: susie9, type: 0, tags:true, filter: "objDetect" },
                { title: "Face Mark", img: susie4, type: 0, tags:false, filter: "faceMark" },
                { title: "Edge Detection", img: susie3, type: 0, tags:false, filter: "edgeDetect" },                

                { title: "Hand", img: susie2, tags:false, type: 1, filter: "hand" },
                { title: "Pose", img: susie8, tags:false, type: 1, filter: "holistic" },

                { title: "3D Geometry", img: susie6, tags:false, type: 2, filter: "geometry", filterList:["Box", "Circle","Cylinder","Icosahedron", "Octahedron","Plane", "Ring", "Sphere","Torus","TorusKnot"] },
                { title: "3D Panorama", img: susie5, tags:false, type: 2, filter: "panorama", filterList:[]},
                { title: "3D Molecule", img: susie7, tags:false, type: 2, filter: "molecule", filterList:["Ethanol", "Aspirin","Caffeine", "Nicotine","LSD","Cocaine","Cholesterol", "Lycopene","Glucose","Aluminium oxide","Cubane", "Copper", "Fluorite","Salt", "YBCO superconductor", "Buckyball", "Graphite"]}
            ],
            geometryMap:{
                "Box": new THREE.BoxGeometry( 200, 200, 200, 2, 2, 2 ), "Circle": new THREE.CircleGeometry( 200, 32 ),
                "Cylinder":new THREE.CylinderGeometry( 75, 75, 200, 8, 8),"Icosahedron": new THREE.IcosahedronGeometry( 100, 1 ), 
                "Octahedron":new THREE.OctahedronGeometry( 200, 0 ),"Plane": new THREE.PlaneGeometry( 200, 200, 4, 4 ), 
                "Ring":new THREE.RingGeometry( 32, 64, 16 ), "Sphere": new THREE.SphereGeometry( 100, 12, 12 ),
                "Torus": new THREE.TorusGeometry( 64, 16, 12, 12 ),"TorusKnot": new THREE.TorusKnotGeometry( 64, 16 )
            },
            moleculeMap: {
				"Ethanol": "ethanol.pdb", "Aspirin": "aspirin.pdb",
				"Caffeine": "caffeine.pdb", "Nicotine": "nicotine.pdb",
				"LSD": "lsd.pdb", "Cocaine": "cocaine.pdb",
				"Cholesterol": "cholesterol.pdb", "Lycopene": "lycopene.pdb",
				"Glucose": "glucose.pdb", "Aluminium oxide": "Al2O3.pdb",
				"Cubane": "cubane.pdb", "Copper": "cu.pdb", "Fluorite": "caf2.pdb", 
                "Salt": "nacl.pdb", "YBCO superconductor": "ybco.pdb", 
                "Buckyball": "buckyball.pdb", "Graphite": "graphite.pdb"
			},
            selectedGeometry: null, panoramaImg: ''
        }

        /* Media Objects */
        this.mediaCamera = null;
        this.mediaCanvas = { ctx: null, element: null };
        this.media3DCamera; this.media3DScene;
        this.media3DRenderer; this.media3DMesh;
        this.media3DLabelRenderer;

        /* Video Streams */
        this.liveVideo = null;
        this.liveSnapshot = null;

        /* References */
        this.filterListRef = React.createRef();
        this.filter3DListRef = React.createRef();

        /* Functions */
        this.moveCtrl = this.moveCtrl.bind(this);
        this.tagBuilder = this.tagBuilder.bind(this);
        this.getSnapShot = this.getSnapShot.bind(this);
        this.serverFilter = this.serverFilter.bind(this);
        this.resetFeed = this.resetFeed.bind(this);
        this.openFilter = this.openFilter.bind(this);
        this.flipVideo = this.flipVideo.bind(this);
        this.toggleLiveVideo = this.toggleLiveVideo.bind(this);
        this.socketDeclaration = this.socketDeclaration.bind(this);

        /* 3D Front Functions */
        this.front3DFilters = this.front3DFilters.bind(this);
        this.init3DGeometry = this.init3DGeometry.bind(this);        
        this.addMesh = this.addMesh.bind(this);
        this.init3DPanorama = this.init3DPanorama.bind(this);
        this.loadImg = this.loadImg.bind(this);
        this.changePanorama = this.changePanorama.bind(this);
        this.loadMolecule = this.loadMolecule.bind(this);
        this.clearMolecule = this.clearMolecule.bind(this);
        this.init3DMolecule = this.init3DMolecule.bind(this);
        this.animate = this.animate.bind(this);
        this.animatePlus = this.animatePlus.bind(this);
        this.render3D = this.render3D.bind(this);
        this.controlResults = this.controlResults.bind(this);
        this.toggle3DFilter = this.toggle3DFilter.bind(this);
        this.moveCube = this.moveCube.bind(this);
        this.degreeChk = this.degreeChk.bind(this);
        this.toggle3DHand = this.toggle3DHand.bind(this);

        /* Front View Functions */
        this.frontFilters = this.frontFilters.bind(this);
        this.connect = this.connect.bind(this);
        this.initHolistic = this.initHolistic.bind(this);
        this.holisticResults = this.holisticResults.bind(this);
        this.initHand = this.initHand.bind(this);
        this.handResults = this.handResults.bind(this);
        this.toggleMediaCamera = this.toggleMediaCamera.bind(this);
    }

    moveCtrl(dir, ref, scrollInt, vert){
        try {  
            if(ref && ref.current) {
                if(vert) {
                    var tmpPos = ref.current.scrollTop + (scrollInt * dir);
                    ref.current.scrollTop = tmpPos; 
                }  
                else {
                    var tmpPos = ref.current.scrollLeft + (scrollInt * dir);
                    ref.current.scrollLeft = tmpPos; 
                }  
            }           
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }
    }

    tagBuilder(tagList){
        try {
            if(this.state.selectedFilter && this.state.selectedFilter.tags && tagList && tagList.length > 0){
                var tmpList = this.state.filterTags;
                tagList = (typeof(tagList[0]) != "object" ? tagList : tagList.map(function(item) { return item.title; }));

                for(var t=0; t < tagList.length; t++){
                    var input = false;
                    
                    for(var i=0;i < tmpList.length; i++){
                        if(tmpList[i].title === tagList[t]){
                            tmpList[i].total++;
                            input = true; break;
                        }
                    }

                    if(!input) { tmpList.push({ title: tagList[t], total: 1 }); }
                }

                this.setState({ filterTags: tmpList.sort(function(a,b){ return b.total - a.total; }) });
            }
        }
        catch(ex){
            console.log("[Error] Building Tag List: ",ex);
        }
    }

     /* Get Snapshot of main video */
     getSnapShot(){
        var ret = null;

        try {
            var video = document.querySelector('video'), shrinkSz = .5, canvas, context;
            if(video) {
                var width = video.offsetWidth * shrinkSz, height = video.offsetHeight * shrinkSz;

                canvas = canvas || document.createElement('canvas');
                canvas.width = width; canvas.height = height;

                context = canvas.getContext('2d');
                context.drawImage(video, 0, 0, width, height);

                ret = canvas.toDataURL('image/png');
            }
        }
        catch(ex){
            console.log(" [Susie] Error getting video snapshot: ", ex);
        }

        return ret;
    }

    serverFilter(filter){
        var self = this;
        try {
            if(this.liveSnapshot != null){
                clearInterval(this.liveSnapshot);
                this.liveSnapshot = null;

                if(filter === this.state.videoFilter){
                    this.setState({ videoFilter: null });
                }
                else {
                    this.serverFilter(filter);
                }
            }
            else if(!this.liveVideo){                
                this.toggleLiveVideo(true, false, function(){ 
                    self.serverFilter(filter);
                });
            }
            else if(filter != null){
                this.setState({ videoFilter: filter }, ()=>{
                    self.liveSnapshot = setInterval(function() {
                        var tmpSnapShot = self.getSnapShot(); 

                        if(!localSock){
                            alert("Socket is not connected");
                            clearInterval(self.liveSnapshot);
                        }
                        else if(tmpSnapShot) {
                            var dataMsg = {
                                "rID":self.state.userId, "filter":filter, 
                                "filterStatus":true, "data":tmpSnapShot
                            }

                            localSock.emit('[susie] view', {"sID":self.state.userId, "rID":self.state.userId, "data":dataMsg});
                        }
                    }, 200);
                });
            }
        }
        catch(ex){
            console.log("[Error] Toggling Server Filter: ",ex);
        }
    }

    resetFeed(videoFilter, callback){
        try {
            // Clear Lingering Molecules
            if(this.media3DLabelRenderer) { this.clearMolecule();}
            // Restart Live Feed
            if(videoFilter && this.liveVideo && this.liveVideo === true) { 
                this.toggleMediaCamera(false);
                this.toggleLiveVideo(true, false, callback);
            }
            else {
                callback();
            }
        }
        catch(ex){
            console.log("[Error] Reseting Feed: ", ex);
            callback();
        }
    }

    openFilter(filter){
        var self = this;
        try {
            var newFilter = (this.state.selectedFilter === null || this.state.selectedFilter.title != filter.title ? filter : null);
            this.setState({ selectedFilter: newFilter, filterTags: [] }, () =>{
                self.resetFeed((newFilter != null), function(){
                    switch(filter.type){
                        case 0:
                            console.log((newFilter == null ? "Stop": "Start") + " Server Filter: " + filter.title);
                            self.serverFilter(filter.filter)
                            break;
                        case 1:
                            console.log((newFilter == null ? "Stop": "Start") + " Front Filter: " + filter.title);
                            self.frontFilters(filter, (newFilter == null));
                            break;
                        case 2:
                            console.log((newFilter == null ? "Stop": "Start") + " 3D Filter: " + filter.title);
                            self.front3DFilters(filter, (newFilter == null));
                            break;
                        default:
                            break;
                    }
                });
            });
        }
        catch(ex){
            console.log("[Error] opening filter: ",ex);
        }
    }

    flipVideo(){
        var self = this;
        try {
            this.setState({ videoFace: !this.state.videoFace }, ()=>{
                if(self.liveVideo != null) {
                    self.liveVideo.stop();
                    self.liveVideo = null;
    
                    document.getElementById('video').srcObject = null;
                    document.getElementById('viewVideo').srcObject = null;
                    self.toggleLiveVideo(true, false, function(){ });
                }
            });
        }
        catch(ex){
            console.log("[Error] flipping video: ",ex);
        }
    }

    toggleLiveVideo(videoSettings, close, callback){
        var self = this;
        try {
            if(self.liveVideo == null && !close) {
                self.setState({ susieLoading: true, filterTags:[] }, ()=>{
                    var faceMode = (this.state.videoFace ? "user" : { exact: "environment" });
                    videoSettings = ( videoSettings == true ? { facingMode: faceMode } : videoSettings);

                    navigator.mediaDevices.getUserMedia({
                        audio: false, video: videoSettings
                    })
                    .then((stream) => {
                        const video = document.getElementById('video');
                        const viewVideo = document.getElementById('viewVideo');

                        video.srcObject = stream;
                        viewVideo.srcObject = stream;

                        self.liveVideo = stream.getTracks()[0];
                        video.onloadedmetadata = (e) => video.play(); 
                        viewVideo.onloadedmetadata = (e) => viewVideo.play(); 

                        self.setState({ susieLoading: false });
                        callback();
                    })
                    .catch((e) => {
                        console.log(e);
                        self.setState({ susieLoading: false });
                        callback();
                    });
                });
            }
            else {
                if(self.state.selectedFilter && !close){ self.openFilter(self.state.selectedFilter); }
                
                if(self.liveVideo !== true){ self.liveVideo.stop(); }
                self.liveVideo = null;

                document.getElementById('video').srcObject = null;
                document.getElementById('viewVideo').srcObject = null;
                callback();
            }
        }
        catch(ex){
            console.log("[Error] Toggling Live Video: ",ex);
            callback();
        }
    }

    socketDeclaration(tmpSock){
        var self = this;
        try {
            imgObj = document.getElementById("filterVideo");

            if(tmpSock) {
                tmpSock.on('[susie] view',function(res) {
                    if(imgObj) {
                        imgObj.src = res.data;
                        if("tags" in res) { self.tagBuilder(res.tags); }
                    }
                });
                localSock = tmpSock;
            }
        }
        catch(ex){
            console.log("Error with socket declaration: ", ex);
        }
    }

    /* 3D Front View Tools */
    front3DFilters(filter, close){
        var self = this;
        
        try {
            var tmpFilter = (filter.filter === this.state.videoFilter ? null : filter.filter);
            this.setState({ videoFilter: tmpFilter }, () =>{
                if(self.liveVideo && self.liveVideo !== true) { self.toggleLiveVideo(true, (tmpFilter != null), function(){ }); }
                switch(filter.filter){
                    case "geometry":
                        self.init3DGeometry(function(){
                            self.animate();
                        });
                        break;
                    case "panorama":
                        self.init3DPanorama((tmpFilter == null), function(){
                            self.animate();
                        });
                        break;
                    case "molecule":
                        self.init3DMolecule((tmpFilter == null), function(){
                            self.animatePlus();
                        });
                        break;
                    default: 
                        break;
                }
            });
        }
        catch(ex){
            console.log("[Error] With 3D Front Filter: ",ex);
        }
    }

    init3DGeometry(callback) {
        var self = this;
        try {
            this.media3DCamera = new THREE.PerspectiveCamera( 70, window.innerWidth / window.innerHeight, 1, 1000 );
            this.media3DCamera.position.z = 500;

            this.media3DScene = new THREE.Scene();
            var geo = (this.state.selectedFilter ? this.state.selectedFilter.filterList[0] : "Box");

            this.addMesh(geo, function(){
                var canvas = document.getElementById("filter3DCanvas");
                self.media3DRenderer = new THREE.WebGLRenderer({ antialias: true, canvas: canvas });
                self.media3DRenderer.setPixelRatio(window.devicePixelRatio);
                if(canvas.clientWidth > 0 && canvas.clientHeight > 0){ self.media3DRenderer.setSize(canvas.clientWidth, canvas.clientHeight); }
                
                const controls = new OrbitControls(self.media3DCamera, self.media3DRenderer.domElement);
                controls.enableZoom = false;
                controls.autoRotate = true;

                callback();
            });
        }
        catch(ex){
            console.log("[Error] With 3D Geometry: ",ex);
            callback();
        }
    }

    addMesh(geo, callback){
        var self = this;
        try {
            if (this.media3DMesh !== undefined) {
                this.media3DScene.remove(this.media3DMesh);
                if(this.state.selectedGeometry) { this.state.selectedGeometry.dispose(); }
                if(this.media3DLabelRenderer) { this.clearMolecule();}
            }

            this.setState({selectedGeometry: this.state.geometryMap[geo]}, () =>{
                // scale geometry to a uniform size
			    self.state.selectedGeometry.computeBoundingSphere();

                const scaleFactor = 160 / self.state.selectedGeometry.boundingSphere.radius;
				self.state.selectedGeometry.scale(scaleFactor, scaleFactor, scaleFactor);

                const material = new THREE.MeshBasicMaterial({ color: 0xfefefe, wireframe: true, opacity: 0.5 });
                self.media3DMesh = new THREE.Mesh(self.state.selectedGeometry, material);
				self.media3DScene.add(self.media3DMesh);

                const vertexNormalsHelper = new VertexNormalsHelper(self.media3DMesh, 10);
				self.media3DMesh.add(vertexNormalsHelper);

                callback();
            });
        }
        catch(ex){
            console.log("[Error] With 3D Mesh: ",ex);
            callback();
        }
    }

    init3DPanorama(close, callback){
        try {
            var canvas = document.getElementById("filter3DCanvas");
            this.media3DRenderer = new THREE.WebGLRenderer({ canvas: canvas });
            this.media3DRenderer.setPixelRatio(window.devicePixelRatio);
            if(canvas.clientWidth > 0 && canvas.clientHeight > 0) { this.media3DRenderer.setSize(canvas.clientWidth, canvas.clientHeight); }

            this.media3DScene = new THREE.Scene();

            this.media3DCamera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1100 );
            this.media3DCamera.position.z = 0.01;            

            const controls = new OrbitControls(this.media3DCamera, this.media3DRenderer.domElement);
            controls.enableZoom = false;
            controls.autoRotate = true;

            if(!close) { this.loadImg('./imgs/panorama/homepan.jpg', callback); }
        }
        catch(ex){
            console.log("[Error] With 3D Panorama: ",ex);
        }
    }

    loadImg(file, callback){
        try {
            if (this.media3DMesh !== undefined) {
                this.media3DScene.remove(this.media3DMesh);
            }   

            const texture = new THREE.TextureLoader().load(file);
            const material = new THREE.MeshBasicMaterial({ map: texture });
            const geometry = new THREE.SphereGeometry(500, 60, 40);

            // invert the geometry on the x-axis so that all of the faces point inward
            geometry.scale(-1, 1, 1 );

            this.media3DMesh = new THREE.Mesh(geometry, material);
			this.media3DScene.add(this.media3DMesh);
        }
        catch(ex){
            console.log("[Error] Loading Panorama Img: ",ex);
        }

        callback();
    }

    changePanorama(e){
        var self = this;
        try {
            var filePath = e.target.value;
            var file = (e.target.files && e.target.files.length > 0 ? e.target.files[0] : null);
            
        }
        catch(ex){
            console.log("[Error] Changing Panorama: ",ex);
        }
    }

    init3DMolecule(close, callback){
        try {
            
            if(this.media3DLabelRenderer) { this.clearMolecule(); }

            var canvas = document.getElementById("filter3DCanvas");
            this.media3DRenderer = new THREE.WebGLRenderer({ canvas: canvas });
            this.media3DRenderer.setPixelRatio(window.devicePixelRatio);
            if(canvas.clientWidth > 0 && canvas.clientHeight > 0) { this.media3DRenderer.setSize(canvas.clientWidth, canvas.clientHeight); }

            this.media3DScene = new THREE.Scene();

            this.media3DCamera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 1, 5000 );
            this.media3DCamera.position.z = 1000;     

            const light1 = new THREE.DirectionalLight(0xffffff, 0.8);
			light1.position.set(1, 1, 1);
			this.media3DScene.add(light1);

			const light2 = new THREE.DirectionalLight(0xffffff, 0.5);
			light2.position.set(-1, -1, 1);
			this.media3DScene.add(light2);

            this.media3DMesh = new THREE.Group();
			this.media3DScene.add(this.media3DMesh);

            this.media3DLabelRenderer = new CSS2DRenderer();
			this.media3DLabelRenderer.setSize(canvas.clientWidth, canvas.clientHeight);
			this.media3DLabelRenderer.domElement.style.position = 'absolute';
			this.media3DLabelRenderer.domElement.style.top = '0px';
			this.media3DLabelRenderer.domElement.style.pointerEvents = 'none';
            document.getElementById('filter3DCanvas').after(this.media3DLabelRenderer.domElement);
        
            const controls = new OrbitControls(this.media3DCamera, this.media3DRenderer.domElement);
            controls.enableZoom = false;
            controls.autoRotate = true;

            var moleculeItem = (this.state.selectedFilter ? this.state.selectedFilter.filterList[0] : "Ethanol");
            
            if(!close) { this.loadMolecule(moleculeItem, callback); }
        }
        catch(ex){
            console.log("[Error] With 3D Molecule: ",ex);
        }
    }
    clearMolecule(){
        try {
            while (this.media3DMesh.children.length > 0) {
                const object = this.media3DMesh.children[0];
                object.parent.remove(object);
            }
        }
        catch(ex){
            console.log("[Error] Clearing Molecule: ",ex);
        }
    }

    loadMolecule(urlItem, callback){
        var self = this;

        try {
            var url = './imgs/molecules/'+ this.state.moleculeMap[urlItem];

            this.clearMolecule();

            const offset = new THREE.Vector3();
            const loader = new PDBLoader();
            loader.load(url, function (pdb) {
                const geometryAtoms = pdb.geometryAtoms;
                const geometryBonds = pdb.geometryBonds;
                const json = pdb.json;

                const boxGeometry = new THREE.BoxGeometry(1, 1, 1);
                const sphereGeometry = new THREE.IcosahedronGeometry(1, 3);

                geometryAtoms.computeBoundingBox();
                geometryAtoms.boundingBox.getCenter(offset).negate();

                geometryAtoms.translate(offset.x, offset.y, offset.z);
                geometryBonds.translate(offset.x, offset.y, offset.z);

                let positions = geometryAtoms.getAttribute( 'position' );
                const colors = geometryAtoms.getAttribute( 'color' );

                const position = new THREE.Vector3();
                const color = new THREE.Color();

                for (let i = 0; i < positions.count; i ++) {
                    position.x = positions.getX(i);
                    position.y = positions.getY(i);
                    position.z = positions.getZ(i);

                    color.r = colors.getX(i);
                    color.g = colors.getY(i);
                    color.b = colors.getZ(i);

                    const material = new THREE.MeshPhongMaterial( { color: color } );

                    const object = new THREE.Mesh(sphereGeometry, material);
                    object.position.copy(position);
                    object.position.multiplyScalar( 75 );
                    object.scale.multiplyScalar( 25 );

                    self.media3DMesh.add(object);

                    const atom = json.atoms[ i ];

                    const text = document.createElement('div');
                    text.className = 'label';
                    text.style.color = 'rgb(' + atom[ 3 ][ 0 ] + ',' + atom[ 3 ][ 1 ] + ',' + atom[ 3 ][ 2 ] + ')';
                    text.textContent = atom[ 4 ];

                    const label = new CSS2DObject( text );
                    label.position.copy( object.position );
                    self.media3DMesh.add(label);
                }

                positions = geometryBonds.getAttribute('position');

                const start = new THREE.Vector3();
                const end = new THREE.Vector3();

                for (let i = 0; i < positions.count; i += 2) {
                    start.x = positions.getX(i);
                    start.y = positions.getY(i);
                    start.z = positions.getZ(i);

                    end.x = positions.getX(i + 1);
                    end.y = positions.getY(i + 1);
                    end.z = positions.getZ(i + 1);

                    start.multiplyScalar( 75 );
                    end.multiplyScalar( 75 );

                    const object = new THREE.Mesh(boxGeometry, new THREE.MeshPhongMaterial(0xffffff));
                    object.position.copy(start);
                    object.position.lerp(end, 0.5);
                    object.scale.set(5, 5, start.distanceTo(end));
                    object.lookAt(end);
                    self.media3DMesh.add(object);
                }

                self.render3D(true);
                callback();
            });
        }
        catch(ex){
            console.log("[Error] Loading Molecule: ",ex);
            callback();
        }
    }

    render3D(plus) { 
        this.media3DRenderer.render(this.media3DScene, this.media3DCamera);
        if(plus) { this.media3DLabelRenderer.render(this.media3DScene, this.media3DCamera); }
    }

    animatePlus() {
        requestAnimationFrame(this.animatePlus);
        this.render3D(true);
    }

    animate() {
        requestAnimationFrame(this.animate);
        this.render3D(false);
    }

    controlResults(results){
        try {
            if(this.state.susieLoading){ this.setState({ susieLoading: false }); }

            this.mediaCanvas.ctx.save();
            this.mediaCanvas.ctx.clearRect(0, 0, this.mediaCanvas.element.width, this.mediaCanvas.element.height);
            
            if (results.multiHandLandmarks && results.multiHandedness) {
                for (let index = 0; index < results.multiHandLandmarks.length; index++) {
                    const classification = results.multiHandedness[index];
                    const isRightHand = classification.label === 'Right';
                    const landmarks = results.multiHandLandmarks[index];
                    
                    var tmpX = Math.ceil(360 * results.multiHandLandmarks[index][8].x.toFixed(2));
					var tmpY = Math.ceil(360 * results.multiHandLandmarks[index][8].y.toFixed(2));
					var tmpZ = Math.ceil(360 * results.multiHandLandmarks[index][8].z.toFixed(2));

					// Switch X & Y 
                    
					this.moveCube({x: tmpX, y: tmpY, z: tmpZ });

                    drawConnectors(this.mediaCanvas.ctx, landmarks, HAND_CONNECTIONS, 
                    { color: isRightHand ? '#fccd04' : '#8a3cb3', lineWidth: 2});
                    
                    drawLandmarks(this.mediaCanvas.ctx, landmarks, 
                    { color: isRightHand ? '#fccd04' : '#8a3cb3', 
                        fillColor: isRightHand ? '#8a3cb3' : '#fccd04',
                        lineWidth: 1, radius: 3
                    });
                }
            }
            this.mediaCanvas.ctx.restore();
        }
        catch(ex){
            console.log("[Error] With Control Results: ",ex);
        }
    }

    toggle3DFilter(sel){
        try {
            switch(this.state.selectedFilter.filter){
                case "geometry":
                    if(sel in this.state.geometryMap){
                        this.addMesh(sel, function(){ });
                    }
                    break;
                case "molecule":
                    if(sel in this.state.moleculeMap){
                        this.loadMolecule(sel, function(){ });
                    }
                    break;
                default:
                    break;
            }
        }
        catch(ex){
            console.log("[Error] Toggling 3D Filters: ",ex);
        }
    }

    moveCube(loc){
        try {
            var xAbs = 0, yAbs = 0, zAbs = 0;
    
            if(this.state.selectedFilter && this.state.selectedFilter.filter === "panorama"){
			    xAbs = (loc.x * Math.PI) / 180;
                yAbs = (this.degreeChk(180+loc.y) * Math.PI) / 180;

                this.media3DMesh.rotation.set(yAbs, xAbs, zAbs);                
            }
            else {
                xAbs = (this.degreeChk(180+loc.x) * Math.PI) / 180;				
			    yAbs = (loc.y * Math.PI) / 180;
                
                this.media3DMesh.rotation.set(yAbs, zAbs, -xAbs);
            }
        }
        catch(ex){
            console.log("[Error] Moving Cube: ",ex);
        }
    }

    degreeChk(deg) {
        if(deg < 0) {
            return this.degreeChk(360 + deg);
        }
        else if(deg > 360){
            return this.degreeChk(0 + (deg - 360));
        }
        else {
            return deg;
        }
    }

    toggle3DHand(){
        var self = this;
        try {
            self.initHand(true, function(){
                self.toggleMediaCamera(false);
            });
        }
        catch(ex){
            console.log("[Error] Toggling 3D Hand: ",ex);
        }
    }

    /* Front View Tools */
    frontFilters(filter, close){
        var self = this;
        try {
            //selectedFilter
            if(!this.liveVideo && !close){                
                this.toggleLiveVideo(true, false, function(){ 
                    self.frontFilters(filter, close);
                });
            }
            else {
                var tmpFilter = (filter.filter === this.state.videoFilter ? null : filter.filter);
                this.setState({ videoFilter: tmpFilter }, () =>{
                    if(self.liveVideo && self.liveVideo !== true) { self.toggleLiveVideo(true, (tmpFilter != null), function(){ }); }
                    switch(filter.filter){
                        case "hand":
                            self.initHand(false, function(){
                                self.toggleMediaCamera(close);
                            });
                            break;
                        case "holistic":
                            self.initHolistic(function(){
                                self.toggleMediaCamera(close);
                            });
                            break;
                        default:
                            break;
                    }   
                });   
            }      
        }
        catch(ex){
            console.log("[Error] With Front Filters: ",ex);
        }
    }

    connect(ctx, connectors) {
        const canvas = ctx.canvas;
        for (const connector of connectors) {
          const from = connector[0];
          const to = connector[1];
          if (from && to) {
            if (from.visibility && to.visibility &&
                (from.visibility < 0.1 || to.visibility < 0.1)) {
              continue;
            }
            ctx.beginPath();
            ctx.moveTo(from.x * canvas.width, from.y * canvas.height);
            ctx.lineTo(to.x * canvas.width, to.y * canvas.height);
            ctx.stroke();
          }
        }
    }

    /* Holistic */
    initHolistic(callback){
        var self = this;
        try {
            if(!("holistic" in this.state.frontMap)){
                this.mediaCanvas.element = document.getElementById('filterCanvas');
                this.mediaCanvas.ctx = this.mediaCanvas.element.getContext('2d');

                const holistic = new Holistic({locateFile: (file) => {
                    return `https://cdn.jsdelivr.net/npm/@mediapipe/holistic/${file}`;
                }});

                holistic.setOptions({
                    upperBodyOnly: false, smoothLandmarks: true,
                    minDetectionConfidence: 0.5, minTrackingConfidence: 0.5
                });

                holistic.onResults(this.holisticResults);

                var tmpDict = this.state.frontMap; tmpDict["holistic"] = holistic;
                this.setState({ frontMap: tmpDict }, () =>{
                    const videoElement = document.getElementById('viewVideo');
                    self.mediaCamera = new Camera(videoElement, {
                        onFrame: async () => {
                            await self.state.frontMap.holistic.send({ image: videoElement });
                        }
                    }); 
                    callback(); 
                });
            }
            else {
                const videoElement = document.getElementById('viewVideo');
                this.mediaCamera = new Camera(videoElement, {
                    onFrame: async () => {
                        await self.state.frontMap.holistic.send({ image: videoElement });
                    }
                }); 
                callback(); 
            }
        }
        catch(ex){
            console.log("[Error] init holistic: ",ex);
            callback();
        }
    }

    holisticResults(results) {
        try {
            if(this.state.susieLoading){ this.setState({ susieLoading: false }); }

            this.mediaCanvas.ctx.save();
            this.mediaCanvas.ctx.clearRect(0, 0, this.mediaCanvas.element.width, this.mediaCanvas.element.height);
            this.mediaCanvas.ctx.drawImage(results.image, 0, 0, this.mediaCanvas.element.width, this.mediaCanvas.element.height);

            // Pose...
            drawConnectors(this.mediaCanvas.ctx, results.poseLandmarks, POSE_CONNECTIONS,{color: '#fccd04', lineWidth: 1});
            drawLandmarks(this.mediaCanvas.ctx, results.poseLandmarks, {color: '#fccd04', fillColor: '#8a3cb3', lineWidth: 1, radius: 1});

            // Hands...
            drawConnectors(this.mediaCanvas.ctx, results.rightHandLandmarks, HAND_CONNECTIONS,{color: '#fccd04', lineWidth: 2});
            drawLandmarks(this.mediaCanvas.ctx, results.rightHandLandmarks, {color: '#fccd04',fillColor: '#8a3cb3', lineWidth: 1, radius: 3 });
            drawConnectors(this.mediaCanvas.ctx, results.leftHandLandmarks, HAND_CONNECTIONS,{color: '#8a3cb3', lineWidth: 2});
            drawLandmarks(this.mediaCanvas.ctx, results.leftHandLandmarks, {color: '#8a3cb3',fillColor: '#fccd04',lineWidth: 1, radius: 3 });

            // Face...
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_TESSELATION,{color: '#C0C0C070', lineWidth: 1});
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_RIGHT_EYE,{color: '#fccd04', lineWidth: 2});
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_RIGHT_EYEBROW,{color: '#fccd04', lineWidth: 2});
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_LEFT_EYE,{color: '#8a3cb3', lineWidth: 2});
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_LEFT_EYEBROW,{color: '#8a3cb3', lineWidth: 2});
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_FACE_OVAL,{color: '#E0E0E0', lineWidth: 2});
            drawConnectors(this.mediaCanvas.ctx, results.faceLandmarks, FACEMESH_LIPS,{color: '#E0E0E0', lineWidth: 2});
            
            // Connect elbows to hands.
            this.mediaCanvas.ctx.lineWidth = 2;

            if (results.poseLandmarks) {
                if (results.rightHandLandmarks) {
                    this.mediaCanvas.ctx.strokeStyle = '#fccd04';
                    this.connect(this.mediaCanvas.ctx, [[results.poseLandmarks[POSE_LANDMARKS.RIGHT_ELBOW], results.rightHandLandmarks[0]]]);
                }

                if (results.leftHandLandmarks) {
                    this.mediaCanvas.ctx.strokeStyle = '#8a3cb3';
                    this.connect(this.mediaCanvas.ctx, [[results.poseLandmarks[POSE_LANDMARKS.LEFT_ELBOW], results.leftHandLandmarks[0]]]);
                }
            }

            this.mediaCanvas.ctx.restore();
        }
        catch(ex){
            console.log("[Error] With Holistic Results: ",ex);
        }
    }

    /* Hand */
    initHand(control, callback){
        var self = this;
        try {
            var mapName = (control ? "ctrlhand" : "hands");

            if(!(mapName in this.state.frontMap)){
                this.mediaCanvas.element = document.getElementById((control ? 'controlCanvas':'filterCanvas'));
                this.mediaCanvas.ctx = this.mediaCanvas.element.getContext('2d');

                const hands = new Hands({ locateFile: (file) => {
                    return `https://cdn.jsdelivr.net/npm/@mediapipe/hands/${file}`;
                }});

                hands.setOptions({ maxNumHands: (control ? 1 : 2), minDetectionConfidence: 0.8, minTrackingConfidence: 0.8, selfieMode: control });
                hands.onResults((control ? this.controlResults : this.handResults));

                var tmpDict = this.state.frontMap; tmpDict[mapName] = hands;
                this.setState({ frontMap: tmpDict }, () =>{
                    const videoElement = document.getElementById('viewVideo');
                    self.mediaCamera = new Camera(videoElement, {
                        onFrame: async () => {
                            await self.state.frontMap[mapName].send({ image: videoElement });
                        }
                    }); 
                    callback(); 
                });
            }
            else {
                const videoElement = document.getElementById('viewVideo');                
                this.mediaCamera = new Camera(videoElement, {
                    onFrame: async () => {
                        await self.state.frontMap[mapName].send({ image: videoElement });
                    }
                });
                callback();  
            }                   
        }
        catch(ex){
            console.log("[Error] init hand: ",ex);
            callback();
        }
    }

    handResults(results) {
        try {
            if(this.state.susieLoading){ this.setState({ susieLoading: false }); }

            this.mediaCanvas.ctx.save();
            this.mediaCanvas.ctx.clearRect(0, 0, this.mediaCanvas.element.width, this.mediaCanvas.element.height);
            this.mediaCanvas.ctx.drawImage(results.image, 0, 0, this.mediaCanvas.element.width, this.mediaCanvas.element.height);
            
            if (results.multiHandLandmarks && results.multiHandedness) {
                for (let index = 0; index < results.multiHandLandmarks.length; index++) {
                    const classification = results.multiHandedness[index];
                    const isRightHand = classification.label === 'Right';
                    const landmarks = results.multiHandLandmarks[index];
                
                    drawConnectors(this.mediaCanvas.ctx, landmarks, HAND_CONNECTIONS, 
                    { color: isRightHand ? '#fccd04' : '#8a3cb3', lineWidth: 2});
                    
                    drawLandmarks(this.mediaCanvas.ctx, landmarks, 
                    { color: isRightHand ? '#fccd04' : '#8a3cb3', 
                        fillColor: isRightHand ? '#8a3cb3' : '#fccd04',
                        lineWidth: 1, radius: 3
                    });
                }
            }
            this.mediaCanvas.ctx.restore();
        }
        catch(ex){
            console.log("[Error] With Hand Results: ",ex);
        }
    }

    toggleMediaCamera(close){
        var self = this;
        try {
            if(self.liveVideo != null || close) {
                var stream = self.mediaCamera.video.captureStream();
                stream.getTracks()[0].stop();
                self.liveVideo = null;
                self.mediaCamera = null;

                if(close) { self.toggleLiveVideo(true, false, function(){ });}
            }
            else {
                self.setState({ susieLoading: true }, ()=>{
                    self.mediaCamera.start();
                    self.liveVideo = true;
                });
            }
        }
        catch(ex){
            console.log("[Error] Stopping Media Camera: ",ex);
        }
    }

    componentDidMount() { 
        var self = this;
        try {              
            navigator.mediaDevices.enumerateDevices().then(function(devices) {
                var videoList = devices.filter(function(item){ return item.kind == "videoinput";});
                self.setState({ videoFlip: videoList.length > 1 });
            });     
            
            var user = this.props.checkUser(false,true);
            if(user) {
                this.setState({ userId: user.userId });
            }
        }
        catch(ex){
            console.log("[Error]: ",ex);
        }
    }

    componentWillUnmount() {
        if(localSock){ localSock.close();  }
    }

    render(){   
        return(
            <div className="page-container susie-page">
                {this.state.susieLoading && <LoadSpinner userClass="susie" /> }
                <SocketConnect socketDeclaration={this.socketDeclaration}/>

                <div className="page-panel susie-view">
                    {/* Top Btn Container */}
                    {!this.state.displayFilters &&
                        <div className="title-btn-container">
                            {(this.state.videoFilter && this.state.selectedFilter && this.state.selectedFilter.type == 2) &&
                                <div className="title-btn icon-btn c3" onClick={this.toggle3DHand}><i className="fas fa-hand-sparkles" /></div>
                            }

                            {!(this.state.selectedFilter && this.state.selectedFilter.type >= 1) && 
                                <div className="title-btn icon-btn c3" onClick={this.flipVideo}><i className="fas fa-sync-alt" /></div>
                            }
                            <div className="title-btn icon-btn" onClick={() => this.toggleLiveVideo(true, false, function(){ })}><i className="fas fa-video" /></div>
                            {this.state.videoFlip && <div className="title-btn icon-btn c2" onClick={()=> this.setState({ displayFilters: true })}><i className="fas fa-chevron-down" /></div> }
                        </div>
                    }

                    {/* Filter Menu */}
                    {this.state.displayFilters && 
                        <div className="filter-menu">
                            <div className="title-btn-container">
                                <div className="title-btn icon-btn c3" onClick={()=> this.setState({ displayFilters: false})}><i className="fas fa-times" /></div>
                            </div>
                            <div className="filter-container">
                                <div className="sel-ctrl top" onClick={() => this.moveCtrl(-1,this.filterListRef, 342, true)}><i className="fas fa-angle-up" /></div>
                                <div className="filter-list" ref={this.filterListRef}>
                                    {this.state.filterList.map((filter,i) =>
                                        <div className="filter-item-container" key={i}>
                                            <div className={"filter-item" + (this.state.selectedFilter && this.state.selectedFilter.title === filter.title ? " sel":"")} onClick={() => this.openFilter(filter)}>
                                                <h2>{filter.title}</h2>
                                                {filter.img !== null && <img src={filter.img} /> }
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="sel-ctrl bottom" onClick={() => this.moveCtrl(1,this.filterListRef, 342, true)}><i className="fas fa-angle-down" /></div>
                            </div>
                        </div>
                    }

                    {/* Full Video View */}
                    <div className="susie-view-container">
                        <img id="filterVideo" className={(!(this.state.videoFilter && this.state.selectedFilter && this.state.selectedFilter.type == 0) ? "inactive": "active")} alt="Susie filtered video" src="" />
                        <canvas id="filterCanvas" className={(!(this.state.videoFilter && this.state.selectedFilter && this.state.selectedFilter.type === 1) ? "inactive": "active")} />
                        <canvas id="filter3DCanvas" className={(!(this.state.videoFilter && this.state.selectedFilter && this.state.selectedFilter.type === 2) ? "inactive": "active")} />
                        <div className={"live-container " + (this.state.videoFilter === null ? "noFilter": "filter") + (this.state.displayFilters ? " noshow":"")}>
                            <video id="video" />
                            <video id="viewVideo" className={(this.state.selectedFilter && this.state.selectedFilter.type == 2 ? "inactive":"")}/>
                            <canvas id="controlCanvas" className={(!(this.state.videoFilter && this.state.selectedFilter && this.state.selectedFilter.type == 2) ? "inactive": "active")} />
                        </div> 

                        {/* 3D Filter Container */}
                        {(this.state.videoFilter && !this.state.displayFilters && this.state.selectedFilter && this.state.selectedFilter.type == 2) &&
                            <div className="filter-3d-container">
                                <div className="filter-ctrl left" onClick={() => this.moveCtrl(-1,this.filter3DListRef, 492, false)}><i className="fas fa-angle-left" /></div>
                                <div className="filter-3d-list" ref={this.filter3DListRef}>
                                    {this.state.selectedFilter.filterList.map((item,i) =>
                                        <div className="filter-item" key={i} onClick={()=> this.toggle3DFilter(item)}>{item}</div>
                                    )}
                                    {/*(this.state.selectedFilter.filter === "panorama") && 
                                        <div className="filter-item">
                                            <input type="file" id="panorama-img" value={this.state.panoramaImg}  onChange={this.changePanorama} accept="image/png, image/jpeg" />
                                        </div>
                                    */}
                                </div>
                                <div className="filter-ctrl right" onClick={() => this.moveCtrl(1,this.filter3DListRef, 492, false)}><i className="fas fa-angle-right" /></div>  
                            </div>
                        }
                    </div>

                    {/* Ordered Tag List */}
                    {(this.state.selectedFilter !== null && this.state.selectedFilter.tags) &&
                        <div className="tag-container">
                            <FlipMove staggerDurationBy="30" duration={1500} typeName="ul"
                                easing="cubic-bezier(0.39,0,0.45,1.4)" staggerDurationBy={50} staggerDelayBy={0}>
                                {this.state.filterTags.map((tag,i) =>
                                    <li className="tag-block" key={i}><div className="tag" key={i}>{tag.title}</div></li>
                                )}
                            </FlipMove>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Susie;